import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { X, ShieldAlert } from "lucide-react";
import { toast } from "sonner";

export default function ImpersonationBanner() {
  const [state, setState] = useState(null);
  useEffect(() => { api.get("/auth/impersonation").then(r=>setState(r.data)).catch(()=>{}); }, []);
  if (!state?.impersonating) return null;
  const end = async () => {
    try { await api.post("/admin/end-impersonation"); toast.success("Back to admin"); window.location.href = "/admin"; }
    catch (e) { toast.error("Failed"); }
  };
  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-red-500/90 text-white px-4 py-2 flex items-center justify-between text-sm shadow-lg">
      <div className="flex items-center gap-2"><ShieldAlert className="w-4 h-4"/>
        <span>Impersonating <strong>{state.target?.display_name || state.target?.email}</strong> · initiated by {state.admin_email}</span>
      </div>
      <Button data-testid="btn-end-impersonation" onClick={end} size="sm" variant="outline" className="bg-white/10 text-white border-white/30 hover:bg-white/20">
        <X className="w-3.5 h-3.5 mr-1"/>End session
      </Button>
    </div>
  );
}
